import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-upcoming-appointment',
  templateUrl: './upcoming-appointment.component.html',
  styleUrls: ['./upcoming-appointment.component.scss'],
})
export class UpcomingAppointmentComponent implements OnInit {
  apptId: any;
  appointmentStatus: any;
  isApptCompleted: boolean = false;
  diagId: any;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService,
    private authService: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  value: String = 'Upcoming';
  appointments: any = [];
  userRole: any;
  status!: string;
  filterForm!: FormGroup;
  tests: any;
  surveys: any;

  selectedTests: any;
  selectedSurveys: any;
  disabledButton: boolean = false;
  show: boolean = false;
  schedules: any;
  page = 4;
  exportErrorMessage: string | null = null;

  ngOnInit(): void {
    let location = null;
    let diagId = null;
    this.status = 'REVIEWED_TILL';
    this.show = false;
    jQuery('.modal-backdrop.fade.show').remove();
    this.spinner.show();

    this.userRole = this.authService.getUserType();
    if (this.userRole != 'ADMIN' && this.userRole != 'DIRECTOR') {
      diagId = this.authenticationService.getUserId();
      this.diagId = diagId;
    }
    this.appointmentService
      .getAppointments(location, diagId, this.status, null, null, null)
      .subscribe((res: any) => {
        this.appointments = res.data;
        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort((a: any, b: any) =>
            new Date(a.appointmentDetails.schedules[0].appointmentDate) <=
            new Date(b.appointmentDetails.schedules[0].appointmentDate)
              ? -1
              : 1
          );
        }

        this.show = true;

        this.spinner.hide();
      });

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
      searchTerm: [''],
    });
  }

  exportCSv() {
    if (!this.appointments || this.appointments.length === 0) {
      this.snackBar.open('No data available to export', 'Close', {
        duration: 3000,
        panelClass: ['custom-snackbar-top'],
      });
      return;
    }

    let csvData = this.convertToCSV(this.appointments);
    let blob = new Blob([csvData], { type: 'text/csv' });
    let url = window.URL.createObjectURL(blob);

    let a = document.createElement('a');
    a.href = url;
    a.download = 'appointments.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  convertToCSV(objArray: any[]) {
    // Handle undefined or incorrect format
    if (!Array.isArray(objArray) || objArray.length === 0) {
      return '';
    }

    let str = '';
    let row = '';

    // Extract headers
    let header = Object.keys(objArray[0]);
    row += header.join(',');
    row += '\r\n';

    // Extract data
    for (let i = 0; i < objArray.length; i++) {
      let line = '';
      for (let index in objArray[i]) {
        if (line != '') line += ',';
        // Check for undefined values and replace them with an empty string
        line += objArray[i][index] !== undefined ? objArray[i][index] : '';
      }
      str += line + '\r\n';
    }
    return str;
  }

  submitFilterForm() {
    this.spinner.show();
    const searchTerm = this.filterForm.get('searchTerm')?.value;
    const fromDate = this.filterForm.get('fromDate')?.value;
    const toDate = this.filterForm.get('toDate')?.value;

    this.appointmentService
      .getAppointments(null, this.diagId, this.status, null, fromDate, toDate)
      .subscribe((res: any) => {
        this.appointments = res.data;

        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort((a: any, b: any) =>
            new Date(a.appointmentDetails.schedules[0].appointmentDate) <=
            new Date(b.appointmentDetails.schedules[0].appointmentDate)
              ? -1
              : 1
          );
        } else {
          // Show message if no records found
          this.snackBar.open('No matching records found', 'Close', {
            duration: 6000,
          });
        }
        this.show = true;
        this.spinner.hide();
      });
  }

  // submitFilterForm() {
  //   this.spinner.show()
  //   this.appointmentService.getAppointments(null,null,this.status,null, this.filterForm.controls['fromDate'].value, this.filterForm.controls['toDate'].value).subscribe((res: any)=>{
  //     this.appointments=res.data;
  //     if (this.appointments.length > 0) {
  //       this.appointments = this.appointments.sort((a: any, b: any) =>(new Date(a.appointmentDetails.schedules[0].appointmentDate)  <= new Date (b.appointmentDetails.schedules[0].appointmentDate) ? -1 : 1));
  //     }
  //     this.show=true
  //     this.spinner.hide()
  //   })
  // }

  getAppointments() {}
  selectValue(value: string) {
    this.value = value;
  }
  setApptId(apptId: any, apptStatus: any) {
    this.isApptCompleted = false;

    if (apptStatus == 'COMPLETE' || apptStatus == 'CANCEL') {
      this.isApptCompleted = true;
    }

    this.apptId = apptId;
  }
  getTestTypes() {}
  addSurveys() {
    var surveys = this.surveys.surveysList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedSurveys = surveys;

    var tests = this.surveys.testsList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedTests = tests;

    let selectedDetails = {
      tests: this.selectedTests,
      surveys: this.selectedSurveys,
      appointmentId: this.apptId,
    };
    this.appointmentService
      .saveSurveyDetails(selectedDetails)
      .subscribe((res) => {
        location.reload();
      });
  }
  disableButton() {}
}
